module.exports = __webpack_public_path__ + "static/media/portfolio_site_optifree_1.0f53f69a.png";